import React from "react";
import "./blockedUser.css";
import { Row, Col, Container, Button } from "reactstrap";
import ShowUploadFiles from "../showUploadFiles/showUploadFiles";

class BlockedUser extends React.Component {
  render() {
    return (
      <div>
      <Row id="blockedUser">
        <Col className="bg-dark">
          <Container className="mt-100px">
            <Row>
              <Col>
                <h1 className="display-3 font36 text-light">
                  Programa NSC Escola
                </h1>
                <p className="font20">
                  Lamentamos o inconveniente mas esta sessão é dedicada as
                  Escolas participantes do projeto BNCC.
                </p>

                <p className="mt-1 font18">
                  NCS Escola é um projeto entre a NSC Comunicações e Governo
                  Federal onde redes escolares credenciadas utilizam os
                  conteúdos veiculados pela NSC Comunições formatados às normas
                  da BNCC auxiliando os Docentes e Alunos aos novos padrões
                  Educacionais Brasileiros normatizados pelo MEC.
                </p>
              </Col>
            </Row>

            <Row>
              <Col xs="12" xl="12" className="mb-2">
                <Button
                  color="primary"
                  size="lg"
                  href="http://basenacionalcomum.mec.gov.br/"
                  target="_blank"
                  className="borderRadius10 mb-5"
                >
                  Conheça o BNCC
                </Button>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <ShowUploadFiles />
      </div>
    );
  }
}

export default BlockedUser;
